module.exports = __webpack_public_path__ + "static/media/2.38fcc18e.jpg";